import { render, staticRenderFns } from "./NewReturn.vue?vue&type=template&id=916810f0&scoped=true&"
import script from "./NewReturn.vue?vue&type=script&lang=js&"
export * from "./NewReturn.vue?vue&type=script&lang=js&"
import style0 from "./NewReturn.vue?vue&type=style&index=0&id=916810f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916810f0",
  null
  
)

component.options.__file = "NewReturn.vue"
export default component.exports